export { default as NormalizePathnameScript } from './NormalizePathnameScript';
